<template>
  <form @submit.prevent="handleFormSubmit()">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="subject">
            Subject
            <span class="invalid" v-if="veeErrors.first('subject')">
              - Field is required
            </span>
          </label>
          <input
            type="text"
            name="subject"
            placeholder="Name or type of issue"
            class="form-control"
            v-model.trim="subject"
            v-validate="'required'"
            data-vv-as="subject"
          />
        </div>
        <div class="form-group">
          <label for="message">
            Message
            <span class="invalid" v-if="veeErrors.first('message')">
              - Field is required
            </span>
          </label>
          <textarea
            type="text"
            name="message"
            placeholder="Describe the issue"
            class="form-control"
            v-model.trim="message"
            v-validate="'required'"
            data-vv-as="message"
          >
          </textarea>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-group text-right">
          <ActionButton
            v-if="!loading"
            :theme="{ primary, secondary, danger, event }"
            label="Submit"
            type="submit"
            style="width: auto; margin-left: auto; margin-bottom: 0;margin-top: 10px;"
          />
          <Spinner style="display: block;float:right" :theme="primary" v-else />
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import ActionButton from "@/components/ActionButton";
import { reportBugEmailer } from "@/helpers/mailer";
import Spinner from "@/components/Spinner";

export default {
  name: "ReportABug",
  components: {
    ActionButton,
    Spinner
    // VueSweetalert2
  },
  data() {
    return {
      subject: "",
      message: "",
      loading: false
    };
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    },
    user() {
      return this.$store.getters.getUser;
    }
  },
  methods: {
    async handleFormSubmit() {
      try {
        const isValid = await this.$validator.validateAll();

        if (!isValid) {
          throw {
            type: "warning",
            title: "Warning",
            error: new Error("Please enter the subject and message")
          };
        }

        this.loading = true;
        let subject = this.subject;
        let message = this.message;
        await reportBugEmailer({ subject, message, user: this.user });
        this.$swal({
          text: "Thank you for submitting your bug report!",
          type: "success"
        }).then(() => {
          this.$emit("close");
        });
      } catch (error) {
        const errType = error.type || "error";
        const errTitle = error.title || "Error";
        const errMsg = error.error.message || error.message;

        this.$toastr[errType](errMsg, errTitle);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss">
.form-group {
  .password-wrapper {
    position: relative;
    img {
      cursor: pointer;
      position: absolute;
      right: 0.75em;
      top: 11px;
      transition: all 0.2s ease;
      &:hover,
      &.is-visible {
        filter: brightness(50%);
      }
    }
  }
  label {
    font-weight: 500;
    font-size: $font-size-xs;
  }
  input,
  textarea {
    border-radius: 5px;
    color: $gray-800;
    font-family: "Gotham Book", sans-serif;
    font-size: $font-size-xs;
  }
}
.swal2-content {
  font-family: "Gotham";
}
</style>
